import { 
    Plugins, 
    CameraResultType, 
    StatusBarStyle } from '@capacitor/core';
const { 
    Device, 
    Network, 
    Share, 
    Clipboard, 
    Camera, 
    Geolocation, 
    SplashScreen, 
    StatusBar, 
    Storage } = Plugins;
export default {
    methods: {
        async platformWeb() {
            const device = await this.deviceInfo();
            return device.platform == 'web';
        },
        async platformMobile() {
            const device = await this.deviceInfo();
            return device.platform != 'web';
        },
        async clearStorage() {
            return await Storage.clear();
        },
        async hideSplashScreen() {
            await SplashScreen.hide();
        },
        async hasConnection() {
            let status = await Network.getStatus();
            return status.connected;
        },
        async copyClipboard(content) {
            await Clipboard.write({
                string: content
            });
        },
        async shareContent(title, body, dialog) {
            if (navigator.share) {
                Share.share({
                  title: title,
                  text: body,
                  dialogTitle: dialog
                });
            }
            else {
                let params = {
                  subject: title,
                  body: body
                }
                window.open("mailto:?" + Object.keys(params).map(k => `${k}=${encodeURI(params[k])}`).join('&'), "_blank"); 
            }
        },
        async deviceInfo() {
            return await Device.getInfo();
        },
        async takePicture() {
            const image = await Camera.getPhoto({
              quality: 90,
              allowEditing: false,
              resultType: CameraResultType.DataUrl
            });
            return image.dataUrl;
        },
        async detectLocation(enableHighAccuracy=false, requireAltitude=false) {
            let position = await Geolocation.getCurrentPosition({ 
                enableHighAccuracy: enableHighAccuracy, 
                requireAltitude: requireAltitude 
              });
            return position.coords;
        },
        async hideStatusBar() {
            if (await this.platformMobile()) {
                StatusBar.hide();
            }
        },
        async showStatusBar(style=StatusBarStyle.Dark, color=process.env.VUE_APP_STATUS_BAR_COLOR) {
            if (await this.platformMobile()) {
                StatusBar.show();
                StatusBar.setStyle({
                    style: style
                });
                StatusBar.setBackgroundColor({
                    color: color
                });
            }
        },
        async scanBarcode(frontCamera=true, flipCamera=true, torchButton=true) {
            return new Promise((resolve, reject) => {
                cordova.plugins.barcodeScanner.scan(
                    (result) => {
                        console.log("scanBarcode", result);
                        resolve(result.text);
                    },
                    (error) => {
                        console.error("scanBarcode", error);
                        reject(error);
                    },
                    {
                        preferFrontCamera: frontCamera, 
                        showFlipCameraButton: flipCamera, 
                        showTorchButton: torchButton, 
                        torchOn: false, 
                        saveHistory: false, 
                        prompt: "Place barcode inside scan area", 
                        resultDisplayDuration: 500, 
                        formats: "ALL_1D,AZTEC,CODABAR,CODE_39,CODE_93,CODE_128,EAN_8,EAN_13,UPC_A,UPC_E,UPC_EAN_EXTENSION,DATA_MATRIX,ITF,MAXICODE,MSI,RSS_14,PDF_417,PLESSEY", // default: all but PDF_417 and RSS_EXPANDED
                        disableAnimations: true, 
                        disableSuccessBeep: false 
                    }
                );
            });
        },
        async scanQrcode(frontCamera=true, flipCamera=true, torchButton=true) {
            return new Promise((resolve, reject) => {
                cordova.plugins.barcodeScanner.scan(
                    (result) => {
                        console.log("scanQrcode", result);
                        resolve(result.text);
                    },
                    (error) => {
                        console.error("scanQrcode", error);
                        reject(error);
                    },
                    {
                        preferFrontCamera: frontCamera, 
                        showFlipCameraButton: flipCamera, 
                        showTorchButton: torchButton, 
                        torchOn: false, 
                        saveHistory: false, 
                        prompt: "Place qrcode inside scan area", 
                        resultDisplayDuration: 500, 
                        formats: "QR_CODE", 
                        disableAnimations: true, 
                        disableSuccessBeep: false 
                    }
                );
            });
        }
    }
};